var _path, _line, _line2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5619 14.5441C25.3499 13.1173 25.7653 11.5146 25.7653 9.88695C25.7653 4.43534 21.1801 0 15.5439 0C9.90766 0 5.32251 4.43534 5.32251 9.88656C5.32251 15.3378 9.90766 19.7731 15.5439 19.7731C17.2266 19.7731 18.8841 19.3717 20.3587 18.6091L24.9891 19.9673C25.064 19.989 25.1406 20 25.2163 20C25.4207 20 25.6211 19.9224 25.7698 19.7782C25.9742 19.5809 26.0495 19.2902 25.9656 19.0227L24.5619 14.5441ZM5.03833 4.71924C4.21896 6.27121 3.75633 8.02762 3.75633 9.88645C3.75633 14.0524 6.07843 17.7027 9.53633 19.6923C9.13764 19.7509 8.72917 19.7813 8.31338 19.7813C6.9988 19.7813 5.70418 19.4732 4.54679 18.8879L1.0103 19.9254C0.935772 19.9475 0.859211 19.9581 0.783056 19.9581C0.57862 19.9581 0.378257 19.8801 0.229206 19.736C0.0251777 19.5386 -0.0501622 19.2483 0.0337298 18.9809L1.106 15.5602C0.500837 14.4407 0.182373 13.1885 0.182373 11.917C0.182373 8.70711 2.18112 5.94034 5.03833 4.71924Z",
    fill: "url(#paint0_linear_2238_219)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.9999,
    y1: 8,
    x2: 20.3206,
    y2: 8,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.9999,
    y1: 12,
    x2: 14.9999,
    y2: 12,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2238_219",
    x1: -3.87421e-7,
    y1: 20,
    x2: 26.9012,
    y2: 18.7029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.b4addcaf45a94ccb45cdb4595a8ae0f4.svg";
export { ForwardRef as ReactComponent };